<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :custom-class="`${
      currentView === 'crypto-payment' ? '' : 'custom-scrollable'
    } ${currentView === 'transaction-processing' ? 'hide-cancel-button' : ''}`"
    label-position="top"
  >
    <main class="-mt-5">
      <!-- head -->
      <section class="flex items-center gap-x-2">
        <div
          v-if="currentView !== 'transaction-processing'"
          class="cursor-pointer z-10 relative"
          @click="setView({ view: 'select-payment-method' })"
        >
          <arrow-left color="white" />
        </div>
        <h3 class="text-white text-lg font-semibold text-center w-full -ml-9">
          {{ title }}
        </h3>
      </section>
      <component :is="computeCurrentView" @setView="setView" />
    </main>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: 'select-payment-method'
    }
  },
  components: {
    SelectPaymentMethod: () =>
      import(
        '@/components/receivePayment/customersView/SelectPaymentMethod.vue'
      ),
    CryptoPayment: () =>
      import('@/components/receivePayment/customersView/CryptoPayment.vue'),
    WalletAddress: () =>
      import('@/components/receivePayment/customersView/WalletAddress.vue'),
    TransactionProcessing: () =>
      import(
        '@/components/receivePayment/customersView/TransactionProcessing.vue'
      ),
    ArrowLeft: () => import('@/assets/icons/ArrowLeft.vue')
  },
  data () {
    return {
      currentView: this.view
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '27%' : breakpoints.mdAndUp ? '60%' : '90%'
    },
    computeCurrentView () {
      return this.currentView
    },
    title () {
      let title
      switch (this.currentView) {
        case 'select-payment-method':
          title = 'Select Payment Method'
          break
        case 'crypto-payment':
          title = 'Pay with Crypto'
      }
      return title
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Payment Link Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    },
    shareLinkHandler () {
      this.currentView = 'shareLink'
    },
    setView (details) {
      this.currentView = details.view
    }
  }
}
</script>

<style scoped>
/* el dialog styles */
>>> .el-dialog {
  background: linear-gradient(
      180deg,
      rgba(35, 42, 101, 0.707965) 9.82%,
      #040932 86.58%
    ),
    linear-gradient(180deg, #2b337b 83.04%, rgba(15, 22, 87, 0) 90.29%);
}
>>> .el-dialog__close::before,
.el-dialog__close::after {
  color: white;
}
>>> .el-dialog__headerbtn .el-dialog__close {
  margin-top: 2rem;
}
>>> .hide-cancel-button .el-dialog__headerbtn {
  display: none !important;
}
</style>
